import type { RootState as S } from "store";

export const certificateDataSelector = (store: S) => store.certificateData.certificateData;
